import { render, staticRenderFns } from "./custom-header.vue?vue&type=template&id=b3b6961c&scoped=true"
import script from "./custom-header.vue?vue&type=script&lang=js"
export * from "./custom-header.vue?vue&type=script&lang=js"
import style0 from "./custom-header.vue?vue&type=style&index=0&id=b3b6961c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b6961c",
  null
  
)

export default component.exports